import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-46b0be0d")

_pushScopeId("data-v-46b0be0d")
const _hoisted_1 = { class: "pptist-editor" }
const _hoisted_2 = { class: "layout-content" }
const _hoisted_3 = { class: "layout-content-center" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_EditorHeader = _resolveComponent("EditorHeader")
  const _component_Thumbnails = _resolveComponent("Thumbnails")
  const _component_CanvasTool = _resolveComponent("CanvasTool")
  const _component_Canvas = _resolveComponent("Canvas")
  const _component_Remark = _resolveComponent("Remark")
  const _component_Toolbar = _resolveComponent("Toolbar")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_EditorHeader, { class: "layout-header" }),
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_Thumbnails, { class: "layout-content-left" }),
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_CanvasTool, { class: "center-top" }),
        _createVNode(_component_Canvas, {
          class: "center-body",
          style: { height: `calc(100% - ${_ctx.remarkHeight + 40}px)` }
        }, null, 8, ["style"]),
        _createVNode(_component_Remark, {
          class: "center-bottom",
          height: _ctx.remarkHeight,
          "onUpdate:height": _cache[1] || (_cache[1] = ($event: any) => (_ctx.remarkHeight = $event)),
          style: { height: `${_ctx.remarkHeight}px` }
        }, null, 8, ["height", "style"])
      ]),
      _createVNode(_component_Toolbar, { class: "layout-content-right" })
    ])
  ]))
})